import {
  SELECTION_CHANGED,
  CLOUD_SELECTION_CHANGED
} from '../actions/s3-direct-actions';

const initialState = {
  access_control  : 'private',
  s3Acceleration  : false,

  selection : {
    size       : 0,
    cost       : 0.0003,
    total_cost : 0,
    count      : 0
  },

  cloud_selection : {
    size       : 0,
    cost       : 0.0003,
    total_cost : 0,
    count      : 0
  }
}

export default function s3Direct(state = initialState, action = {}) {

  switch (action.type) {
    case SELECTION_CHANGED:
      return {
        ...state,
        selection : action.selection
      }
    case CLOUD_SELECTION_CHANGED:
      return {
        ...state,
        cloud_selection : action.cloud_selection
      }
    default:
      return state;
  }
}
